import { useSubmitPayment } from './useSubmitPayment';

export const useHighlightAdvert = ({ item, table, id }) => {
    const submit = useSubmitPayment();
    return {
        highlightWeek: () =>
            submit({ plan: 'highlight_week', table, id, item }),
        highlightMonth: () =>
            submit({ plan: 'highlight_month', table, id, item }),
    };
};
